import React, { PropsWithChildren } from 'react';
import CommonTable from '@/pages/dashboard/components/CommonTable';
import { useMultiAiSummary } from '@/pages/dashboard/utils/customHook';
import { IRankingChangeTableProps } from './types';
import './index.scss';
import classNames from 'classnames';
import { IAiTableData } from '@/pages/dashboard/pages/changeAnalysis/components/ChangeAnalysisAiTable/type';
import { handleSortChange, useRankingChangeTableData, useRankingChangeTableEffects, useRankingChangeTableState } from '@/pages/dashboard/pages/changeAnalysis/components/RankingChangeTable/hook';
import { MetricsCardWrapContentHeader } from '@/pages/dashboard/pages/changeAnalysis/components/RankingChangeTable/components/MetricsCardWrapContentHeader';

export const RankingChangeTable: React.FC<IRankingChangeTableProps & PropsWithChildren> = (props) => {
  const {
    className,
    style,
    data,
    changeData,
    dataKey = 'tableData',
    config,
  } = props;

  const {
    aiConfig,
    defaultSegment,
    gameNameMap = {},
    metricsCardWrapProps,
    commonBaseTableProps,
  } = config || {};

  const {
    tableConfig,
    columns = [],
    ...restCommonBaseTableProps
  } = commonBaseTableProps || {};

  const {
    pagination,
    ...restTableConfig
  } = tableConfig || {};

  const {
    platform,
    pageSize,
    setPageSize,
    pageIndex,
    setPageIndex,
    sortedData,
    setSortedData,
    handlePlatformChange,
  } = useRankingChangeTableState({defaultSegment, pagination});

  const { platformDimMap = {} } = data || {};

  const transformedData = useRankingChangeTableData(data?.[dataKey]?.data || [], platform, gameNameMap, platformDimMap);
  restCommonBaseTableProps.dataSource = transformedData;

  useRankingChangeTableEffects({changeData, platform, columns, metricsCardWrapProps, transformedData: !sortedData?.length ? transformedData : sortedData});

  const { data: aiData, loading: aiLoading } = useMultiAiSummary({
    data: data as Record<string, IAiTableData | undefined>,
    aiConfig: aiConfig || [],
  });

  return (
    <div
      className={classNames('dbd-ranking-change-table', className)}
      style={style}
    >
      <CommonTable
        data={data}
        dataKey={dataKey}
        metricsCardWrapProps={{
          contentHeader: (
            <MetricsCardWrapContentHeader
              aiData={aiData}
              aiLoading={aiLoading}
              platform={platform}
              handlePlatformChange={handlePlatformChange}
            />
          ),
          ...metricsCardWrapProps,
        }}
        commonBaseTableProps={{
          columns,
          tableConfig: {
            onSortChange: handleSortChange(transformedData, setSortedData),
            pagination: {
              total: transformedData.length,
              pageSize,
              pageIndex,
              onPageSizeChange: (query) => {
                setPageSize(query?.pageSize || pagination?.pageSize || 10);
                setPageIndex(query?.pageIndex || pagination?.pageIndex || 1);
              },
            },
            ...restTableConfig,
          },
          ...restCommonBaseTableProps,
        }}
      />
    </div>
  );
};

export default RankingChangeTable;
